import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../App.css";

function Main() {
  const picBackground = "/static/yellowstone.jpg";

  const navigate = useNavigate();

  const navigateExperience = () => {
    navigate("/experience");
  };
  const navigateProjects = () => {
    navigate("/projects");
  };

  const openLinkedIn = () => {
    window.open("https://www.linkedin.com/in/mchugh-brandon/", "_blank");
  };

  const subSectionButtonSx = () => ({
    backgroundColor: "black",
    marginX: { xs: 0.5, sm: 1 },
    marginY: { xs: 2, sm: 5 },
    fontFamily: "roboto slab",
    fontSize: { xs: "0.875rem", sm: "1rem" },
    padding: { xs: "8px 16px", sm: "10px 22px" },
    "&:hover": {
      backgroundColor: "#10b981"
    }
  });

  return (
    <Box
        sx={{
          position: "relative",
          height: "100vh",
          overflow: "hidden"
        }}
      >
        {picBackground && (
          <Box
            sx={{
              backgroundImage: `url(${picBackground})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: -1,
              "::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)" // Adjust the opacity as needed
              }
            }}
          />
        )}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          marginTop={{ xs: 2, sm: 6 }}
          sx={{ 
            color: "white", 
            textAlign: "center",
            paddingX: { xs: 2, sm: 3 }
          }}
        >
          <Typography 
            variant="h1" 
            fontFamily="roboto slab" 
            fontWeight={400} 
            gutterBottom
            sx={{
              fontSize: { xs: "4rem", sm: "3.5rem", md: "6rem" },
              lineHeight: 1.2
            }}
          >
            Brandon Lloyd McHugh
          </Typography>
          <Typography 
            variant="h3" 
            fontFamily="roboto slab" 
            gutterBottom
            sx={{
              fontSize: { xs: "2rem", sm: "2rem", md: "3rem" }
            }}
          >
            Product Engineer
          </Typography>
          <Typography 
            variant="h4" 
            fontFamily="roboto slab" 
            gutterBottom
            sx={{
              fontSize: { xs: "1.5rem", sm: "1.5rem", md: "2.125rem" }
            }}
          >
            Morristown, New Jersey
          </Typography>
          <Box 
            sx={{ 
              display: "flex", 
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 1, sm: 0 },
              width: { xs: "100%", sm: "auto" },
              maxWidth: { xs: "300px", sm: "none" }
            }}
          >
            <Button onClick={navigateExperience} variant="contained" sx={subSectionButtonSx} fullWidth={{ xs: true, sm: false }}>
              Experience
            </Button>
            <Button onClick={navigateProjects} variant="contained" sx={subSectionButtonSx} fullWidth={{ xs: true, sm: false }}>
              Projects
            </Button>
            <Button onClick={openLinkedIn} variant="contained" sx={subSectionButtonSx} fullWidth={{ xs: true, sm: false }}>
              LinkedIn
            </Button>
          </Box>
        </Box>
      </Box>
  );
}

export default Main;
